import { render, staticRenderFns } from "./Negara.vue?vue&type=template&id=6899584e&"
import script from "./Negara.vue?vue&type=script&lang=js&"
export * from "./Negara.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports